import React, { useState, useEffect } from "react";
// import { connect } from "react-redux";
import { Link } from "react-router-dom";
// import constants from "../../../constants";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import MapModal from "../Map/MapModal";

import LoadMoreList from "../../../services/LoadMoreList";
import {
  concateAddress,
  convertToOriginalForm,
  viewGlobalMapURL,
} from "../../../services/StringOperation";
import { FaMapMarker, FaMapMarkerAlt } from "react-icons/fa";

const MyAssignmentListMobile = ({
  assignmentTypeParam,
  myAssignmentsDetails,
  ...props
}) => {
  const [myassignments, SetMyAssignments] = useState([]);
  const [setFilter] = useState("");
  const [selectedDestination, setSelectedDestination] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [originAddress, setOriginAddress] = useState("");

  const userData = useSelector((state) => state.userProfile?.userData);

  useEffect(() => {
    const filterAssignments = myAssignmentsDetails.filter(
      (assign) =>
        assign.cnd_assignment_status ===
        (assignmentTypeParam ? assignmentTypeParam : "Assigned"),
    );
    SetMyAssignments(filterAssignments);
  }, [myAssignmentsDetails]);

  // useEffect(() => {
  //   SetMyAssignments(myAssignmentsDetails);
  // }, [myAssignmentsDetails]);

  // Filter Data - Start
  const [inputValue, setInputValue] = useState("");
  const matchesSearchText = (assign) => {
    const searchText = inputValue.toLowerCase();
    if (assignmentTypeParam == "Cancelled") {
      return (
        format(new Date(assign.cnd_assignment_availability_date), "dd-MM-yyyy")
          ?.toLowerCase()
          ?.includes(searchText) ||
        assign.cnd_assignment_availability_date
          ?.toLowerCase()
          ?.includes(searchText) ||
        assign.cnd_availability_week_day?.toLowerCase()?.includes(searchText) ||
        assign.cnd_assignment_start_time?.toLowerCase()?.includes(searchText) ||
        assign.cnd_assignment_end_time?.toLowerCase()?.includes(searchText) ||
        assign.clt_company_name?.toLowerCase()?.includes(searchText) ||
        assign.clt_branch_name?.toLowerCase()?.includes(searchText) ||
        assign.cnd_assignment_cancel_reason
          ?.toLowerCase()
          ?.includes(searchText) ||
        assign.cnd_assignment_cancel_comment
          ?.toLowerCase()
          ?.includes(searchText) ||
        assign.cnd_assignment_work_shift_type
          ?.toLowerCase()
          ?.includes(searchText) ||
        assign.cnd_assignment_health_and__safety_implications
          ?.toLowerCase()
          ?.includes(searchText)
      );
    } else {
      return (
        format(new Date(assign.cnd_assignment_availability_date), "dd-MM-yyyy")
          ?.toLowerCase()
          ?.includes(searchText) ||
        assign.cnd_assignment_availability_date
          ?.toLowerCase()
          ?.includes(searchText) ||
        assign.cnd_availability_week_day?.toLowerCase()?.includes(searchText) ||
        assign.cnd_assignment_start_time?.toLowerCase()?.includes(searchText) ||
        assign.cnd_assignment_end_time?.toLowerCase()?.includes(searchText) ||
        assign.clt_branch_location?.toLowerCase()?.includes(searchText) ||
        assign.clt_branch_address1?.toLowerCase()?.includes(searchText) ||
        assign.clt_branch_address2?.toLowerCase()?.includes(searchText) ||
        assign.clt_branch_region?.toLowerCase()?.includes(searchText) ||
        assign.clt_branch_postal?.toLowerCase()?.includes(searchText) ||
        (assign.cnd_assignment_job_roles
          ? convertToOriginalForm(assign?.cnd_assignment_job_roles)
              ?.toLowerCase()
              ?.includes(searchText)
          : "") ||
        assign.clt_company_name?.toLowerCase()?.includes(searchText) ||
        assign.cnd_assignment_work_shift_type
          ?.toLowerCase()
          ?.includes(searchText) ||
        assign.pay_and_charge_pay_rate?.toLowerCase()?.includes(searchText) ||
        assign.cnd_assignment_health_and__safety_implications
          ?.toLowerCase()
          ?.includes(searchText)
      );
    }
  };

  // Filter applied jobs based on the search text
  const filterRows = myassignments
    ? myassignments.filter(matchesSearchText)
    : [];
  // Filter Data - End

  useEffect(() => {
    if (userData) {
      const profileAddress = [
        userData.cnd_street_address,
        userData.cnd_street_address_2,
        userData.cnd_town,
        userData.cnd_region,
        userData.cnd_postcode,
      ]
        .filter(Boolean)
        .join(", ");

      setOriginAddress(profileAddress);
    }
  }, [userData]);

  const handleEyeClick = (destination) => {
    setSelectedDestination(destination);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedDestination("");
  };

  return (
    <React.Fragment>
      <div className="m-b30 wrapper">
        <div className="container">
          <div className="row">
            <div className="col-sm-6"></div>
            <div className="col-sm-6 p-2">
              <div className="form-group form-group-default">
                <input
                  type="text"
                  name="search"
                  className="form-control "
                  placeholder="Enter here"
                  onInput={(event, value) => {
                    setInputValue(event.target.value);
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <LoadMoreList
          data={filterRows}
          initialCount={5}
          noDataMessage="No Result Found"
          renderItem={(myassignment, i) => {
            return (
              <ul
                className="nav navbar-nav border border-grey p-4 mb-2"
                style={{ borderRadius: "20px" }}
                key={i}
              >
                <li className="text-dark mb-1">
                  {/* <i className="fa fa-user-circle mr-1 text-primary"></i>{" "} */}
                  <b className="mr-1">Client Name:</b>
                  {/* {myassignment.clt_company_name
                    ? myassignment.clt_company_name.length <= 15
                      ? myassignment.clt_company_name
                      : myassignment.clt_company_name
                    : ""} */}
                  {myassignment.clt_company_name
                    ? myassignment.clt_company_name
                    : ""}
                </li>
                {/* {myassignment.cnd_assignment_client_branch_id &&
                  myassignment.cnd_assignment_client_branch_id ==
                    myassignment.clt_branch_id && ( */}
                <li className="text-dark mb-1">
                  {/* <i className="fa fa-sitemap mr-1 text-primary"></i>{" "} */}
                  <b className="mr-1">Branch Name:</b>
                  {myassignment.cnd_assignment_client_branch_id &&
                    myassignment.cnd_assignment_client_branch_id ==
                      myassignment.clt_branch_id && (
                      <>
                        {myassignment.clt_branch_location
                          ? String(
                              myassignment.clt_branch_name +
                                " - ( " +
                                myassignment.clt_branch_location +
                                " )",
                            ).length <= 15
                            ? myassignment.clt_branch_name +
                              " - ( " +
                              myassignment.clt_branch_location +
                              " )"
                            : myassignment.clt_branch_name
                          : myassignment.clt_branch_name &&
                              myassignment.clt_branch_name.length <= 15
                            ? myassignment.clt_branch_name
                            : myassignment.clt_branch_name
                              ? myassignment.clt_branch_name
                              : ""}
                      </>
                    )}
                  {!myassignment.cnd_assignment_client_branch_id && (
                    <>
                      {myassignment.clt_service_town
                        ? String(
                            myassignment.clt_company_name +
                              " - ( " +
                              myassignment.clt_service_town +
                              " )",
                          ).length <= 15
                          ? myassignment.clt_company_name +
                            " - ( " +
                            myassignment.clt_service_town +
                            " )"
                          : String(
                              myassignment.clt_company_name +
                                " - ( " +
                                myassignment.clt_service_town +
                                " )",
                            )
                        : myassignment.clt_company_name &&
                            myassignment.clt_company_name.length <= 15
                          ? myassignment.clt_company_name
                          : myassignment.clt_company_name
                            ? myassignment.clt_company_name
                            : ""}
                    </>
                  )}
                </li>
                {/* )} */}
                <li className="text-dark mb-1">
                  {/* <i className="fa fa-calendar-o mr-1 text-primary"></i>{" "} */}
                  <b className="mr-1">Date:</b>
                  {format(
                    new Date(myassignment.cnd_assignment_availability_date),
                    "dd-MM-yyyy",
                  ) +
                    " (" +
                    myassignment.cnd_availability_week_day
                      .split(" ")
                      .map(
                        (word) => word.charAt(0).toUpperCase() + word.slice(1),
                      )
                      .join(" ") +
                    ")"}
                </li>
                <li className="text-dark mb-1">
                  {/* <i className="fa fa-clock-o mr-1 text-primary"></i>{" "} */}
                  <b className="mr-1">Timing:</b>
                  {myassignment.cnd_assignment_start_time +
                    " - " +
                    myassignment.cnd_assignment_end_time}
                  {myassignment.cnd_assignment_work_shift_type == "regular"
                    ? " - (Regular)"
                    : myassignment.cnd_assignment_work_shift_type
                      ? " - " + myassignment.cnd_assignment_work_shift_type
                      : ""}
                </li>

                {assignmentTypeParam == "Cancelled" ? (
                  <>
                    {myassignment.cnd_assignment_cancel_reason && (
                      <li className="text-dark mb-1">
                        {/* <i className="fa fa-sticky-note mr-1 text-primary"></i>{" "} */}
                        <b className="mr-1">Reason:</b>
                        {myassignment.cnd_assignment_cancel_reason
                          ? myassignment.cnd_assignment_cancel_reason
                          : ""}
                      </li>
                    )}
                    {myassignment.cnd_assignment_cancel_comment && (
                      <li className="text-dark mb-1">
                        {/* <i className="fa fa-commenting mr-1 text-primary"></i>{" "} */}
                        <b className="mr-1">Comment:</b>
                        {myassignment.cnd_assignment_cancel_comment
                          ? myassignment.cnd_assignment_cancel_comment
                          : ""}
                      </li>
                    )}
                  </>
                ) : (
                  <>
                    <li className="text-dark mb-1">
                      {/* <i className="fa fa-suitcase mr-1 text-primary"></i>{" "} */}
                      <b className="mr-1">Job Title:</b>
                      {myassignment.cnd_assignment_job_roles
                        ? String(
                            convertToOriginalForm(
                              myassignment.cnd_assignment_job_roles,
                            ),
                          ).length <= 15
                          ? convertToOriginalForm(
                              myassignment.cnd_assignment_job_roles,
                            )
                          : convertToOriginalForm(
                              myassignment.cnd_assignment_job_roles,
                            )
                        : ""}
                    </li>
                    {/* Pay Rate - Start */}
                    <li className="text-dark mb-1">
                      {/* <i className="fa fa-money mr-1 text-primary"></i>{" "} */}
                      <b className="mr-1">Pay Rate:</b>
                      {myassignment.pay_and_charge_pay_rate
                        ? String(
                            convertToOriginalForm(
                              myassignment.pay_and_charge_pay_rate,
                            ),
                          ).length <= 15
                          ? convertToOriginalForm(
                              myassignment.pay_and_charge_pay_rate,
                            )
                          : convertToOriginalForm(
                              myassignment.pay_and_charge_pay_rate,
                            )
                        : ""}
                    </li>
                    {/* Pay Rate - End */}
                    {concateAddress(
                      myassignment.clt_branch_address1,
                      myassignment.clt_branch_address2,
                      myassignment.clt_branch_town,
                      myassignment.clt_branch_region,
                      myassignment.clt_branch_postal,
                    ) && (
                      <>
                        <li
                          className="text-dark cursor-pointer mb-1"
                          onClick={() =>
                            viewGlobalMapURL(
                              concateAddress(
                                myassignment.clt_branch_address1,
                                myassignment.clt_branch_address2,
                                myassignment.clt_branch_town,
                                myassignment.clt_branch_region,
                                myassignment.clt_branch_postal,
                              ),
                            )
                          }
                        >
                          {/* <i className="fa fa-map-marker mr-1 text-primary"></i>{" "} */}
                          <b className="mr-1">Address:</b>
                          <text className="text-primary cursor-pointer">
                            {concateAddress(
                              myassignment.clt_branch_address1,
                              myassignment.clt_branch_address2,
                              myassignment.clt_branch_town,
                              myassignment.clt_branch_region,
                              myassignment.clt_branch_postal,
                            ) &&
                            String(
                              concateAddress(
                                myassignment.clt_branch_address1,
                                myassignment.clt_branch_address2,
                                myassignment.clt_branch_town,
                                myassignment.clt_branch_region,
                                myassignment.clt_branch_postal,
                              ),
                            ).length <= 20
                              ? concateAddress(
                                  myassignment.clt_branch_address1,
                                  myassignment.clt_branch_address2,
                                  myassignment.clt_branch_town,
                                  myassignment.clt_branch_region,
                                  myassignment.clt_branch_postal,
                                )
                              : concateAddress(
                                  myassignment.clt_branch_address1,
                                  myassignment.clt_branch_address2,
                                  myassignment.clt_branch_town,
                                  myassignment.clt_branch_region,
                                  myassignment.clt_branch_postal,
                                )}
                          </text>
                        </li>
                      </>
                    )}
                  </>
                )}

                {/* Health & Safety Implications - Start */}
                <li className="text-dark mb-1">
                  {/* <i className="fa fa-medkit mr-1 text-primary"></i>{" "} */}
                  <b className="mr-1">Health & Safety Implications:</b>
                  {myassignment.cnd_assignment_health_and__safety_implications
                    ? String(
                        convertToOriginalForm(
                          myassignment.cnd_assignment_health_and__safety_implications,
                        ),
                      ).length <= 15
                      ? convertToOriginalForm(
                          myassignment.cnd_assignment_health_and__safety_implications,
                        )
                      : convertToOriginalForm(
                          myassignment.cnd_assignment_health_and__safety_implications,
                        )
                    : ""}
                </li>
                {/* Health & Safety Implications - End */}
                <li className="text-dark mb-1 d-flex align-items-center">
                  <b className="mr-1">Get Direction:</b>

                  <FaMapMarkerAlt
                    size={22}
                    className="text-primary cursor-pointer"
                    title="Get Direction"
                    onClick={() =>
                      handleEyeClick(
                        concateAddress(
                          myassignment.clt_branch_address1,
                          myassignment.clt_branch_address2,
                          myassignment.clt_branch_town,
                          myassignment.clt_branch_region,
                          myassignment.clt_branch_postal,
                        ),
                      )
                    }
                  />
                </li>
              </ul>
            );
          }}
        />
      </div>
      <MapModal
        isOpen={isModalOpen}
        profileOrigin={originAddress}
        destination={selectedDestination}
        onClose={closeModal}
      />
    </React.Fragment>
  );
};

export default MyAssignmentListMobile;
